import {TagState} from './TagSelect.types'

export const getBestTextColor = (bgColor: string): string => {
  // Remove the leading # if present
  const hex = bgColor.replace('#', '')

  // Convert hex to RGB
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)

  // Calculate relative luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255

  // Return white for dark backgrounds, black for light backgrounds
  return luminance > 0.5 ? '#000000' : '#FFFFFF'
}

export const filterTags = (tags: TagState[]): TagState[] => {
  return tags.filter((tag) => {
    if (tag.type) {
      return !tag.isHidden && tag.type !== 'list'
    }
    return !tag.isHidden
  })
}

export const mapTagToOption = (tag: TagState) => ({
  value: tag._id,
  label: tag.name,
  color: tag.color || '#ffffff',
})
